import { useState } from 'react'
import { Link } from 'react-router-dom'

import { useForgotPassword } from '../../hooks/queries'
import { useTexte } from '../../texte'

/**
 * Passwort vergessen -- Schritt eins.
 *
 * Nach dem Abschicken steht hier immer derselbe Satz, auch wenn es die
 * Adresse gar nicht gibt. Alles andere machte das Formular zu einem
 * Verzeichnis: wer eine Adresse durchprobiert, wüsste sonst, wer mitliest.
 */
export function ForgotPage() {
  const texte = useTexte()
  const t = texte.anmeldung
  const forgot = useForgotPassword()
  const [email, setEmail] = useState('')

  if (forgot.isSuccess) {
    return (
      <div className="centered">
        <div className="card">
          <h1>{t.postfachTitel}</h1>
          <p className="card__lead">
            {t.postfachVor}
            <strong>{email}</strong>
            {t.postfachNach}
          </p>
          <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>{t.postfachSpam}</p>
          <Link className="button button--outline" to="/login">
            {t.zurueckZurAnmeldung}
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="centered">
      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          forgot.mutate(email)
        }}
      >
        <h1>{t.vergessenTitel}</h1>
        <p className="card__lead">{t.vergessenLead}</p>

        {forgot.isError && <p className="notice" role="alert">{forgot.error.message}</p>}

        <label className="field">
          <span className="field__label">{t.email}</span>
          <input
            className="field__input"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <button className="button" type="submit" disabled={forgot.isPending}>
          {forgot.isPending ? texte.allgemein.laeuft : t.linkAnfordern}
        </button>

        <p style={{ marginTop: 18, textAlign: 'center', fontSize: 14 }}>
          <Link to="/login">{t.zurueckZurAnmeldung}</Link>
        </p>
      </form>
    </div>
  )
}
